/**
 * Checks if href is external. Supports the following:
 *   mailto:anything
 *   https://anything
 *   ftp://anything
 *   //anything
 *
 * @param href string
 * @returns boolean
 */
export const isExternal = (href: string): boolean =>
  /^(([\w]+:)?\/\/|[\w]+:)[\w]/.test(href)
